var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list",
    clipPath: "url(#clip0_744_4723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.58496 1.875C1.06543 1.875 0.647461 2.29297 0.647461 2.8125V4.6875C0.647461 5.20703 1.06543 5.625 1.58496 5.625H3.45996C3.97949 5.625 4.39746 5.20703 4.39746 4.6875V2.8125C4.39746 2.29297 3.97949 1.875 3.45996 1.875H1.58496ZM7.20996 2.8125C6.69043 2.8125 6.27246 3.23047 6.27246 3.75C6.27246 4.26953 6.69043 4.6875 7.20996 4.6875H19.085C19.6045 4.6875 20.0225 4.26953 20.0225 3.75C20.0225 3.23047 19.6045 2.8125 19.085 2.8125H7.20996ZM7.20996 9.0625C6.69043 9.0625 6.27246 9.48047 6.27246 10C6.27246 10.5195 6.69043 10.9375 7.20996 10.9375H19.085C19.6045 10.9375 20.0225 10.5195 20.0225 10C20.0225 9.48047 19.6045 9.0625 19.085 9.0625H7.20996ZM7.20996 15.3125C6.69043 15.3125 6.27246 15.7305 6.27246 16.25C6.27246 16.7695 6.69043 17.1875 7.20996 17.1875H19.085C19.6045 17.1875 20.0225 16.7695 20.0225 16.25C20.0225 15.7305 19.6045 15.3125 19.085 15.3125H7.20996ZM0.647461 9.0625V10.9375C0.647461 11.457 1.06543 11.875 1.58496 11.875H3.45996C3.97949 11.875 4.39746 11.457 4.39746 10.9375V9.0625C4.39746 8.54297 3.97949 8.125 3.45996 8.125H1.58496C1.06543 8.125 0.647461 8.54297 0.647461 9.0625ZM1.58496 14.375C1.06543 14.375 0.647461 14.793 0.647461 15.3125V17.1875C0.647461 17.707 1.06543 18.125 1.58496 18.125H3.45996C3.97949 18.125 4.39746 17.707 4.39746 17.1875V15.3125C4.39746 14.793 3.97949 14.375 3.45996 14.375H1.58496Z",
    fill: "#434356"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList20Px);
export default __webpack_public_path__ + "static/media/list-20px.22acaf9bbd907f0da4a45aecd6a17c36.svg";
export { ForwardRef as ReactComponent };